<template>
  <div v-wechat-title="title"  v-if="surgeryId&&surgeryId>0" class="padding10">
    <div v-for="(s) in surgeries" :key='s.id' class="align-left font-size12 padding10">
      <el-link @click="gotoAnesthesiaIndex(s.id)">
        <span class="el-icon-location fg-primary font-size14"   v-if="surgeryId == s.id" ></span>
        <span class="el-icon-location fg-info font-size14"   v-else ></span>
        {{s.apply_time&&$moment(s.apply_time).format('YYYY/MM/DD HH:mm')||'--'}}
        <span class="fg-info">{{s.surgery_status}}</span>
        <span class="circle fg-red borderd" v-if="s.is_reoperation">再</span>
      </el-link>
    </div>
  </div>
  <p v-else class="no-surgery">
    暂无手术
  </p>
</template>
<script>
export default {
    name: `ReOperationsList`,
    props: {

    },
    data() {
        return {
            title: `再次手术切换`,
            surgeryId: this.$route.query.surgery_id,
            token: this.$route.query.token,
            surgeries: []
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
        }
    },
    mounted() {
        this.loadAssociatedOperations()
    },
    computed: {
    },
    methods: {
        loadAssociatedOperations() {
            let req = this.myaxios.post(`api/Intraoperative/Anaesthesia/AssociatedOperations?surgeryInfoId=${this.surgeryId}`)
            req.then(data => {
                this.surgeries = data
            })
        },
        gotoAnesthesiaIndex(surgeryId) {
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    action: `openAnes`,
                    id: surgeryId
                }
                winformMsg.acceptMessage(cefJson)
            }
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.surgeryId = newUrl.query.surgery_id
            this.loadAssociatedOperations()
        }
    }
}
</script>
<style scoped>
  .no-surgery{
    line-height: 600px;
    font-size: 24px;
    opacity: 0.5;
  }
  h3{
    margin:0
  }
</style>
<style  lang="less">

</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/ReOperationsList.vue